import { get, post, put, del } from "../api_helper"
import { getApiConfig } from "../authHelper"

export const createSalesUser = data => post("/sales-person", data, getApiConfig())
export const logoutRoleSessions = role => post("/user/admin/logout-role-sessions", { role }, getApiConfig())
export const getSalesAccounts = () => get("/sales-person/accounts", getApiConfig())
export const updateSalesUser = (userId, data) => put(`/sales-person/${userId}`, data, getApiConfig())
export const deleteSalesUser = userId => del(`/sales-person/${userId}`, getApiConfig())
